function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
import isEmpty from "lodash/isEmpty";
import { deserialize } from "./helpers";
const PAGE_LIMIT_KEY = 'page[limit]';
var _raw = new WeakMap(), _rawData = new WeakMap(), _links = new WeakMap(), _isNeedRaw = new WeakMap(), _meta = new WeakMap(), _data = new WeakMap(), _apiClient = new WeakMap(), /**
   * Parses and unwraps response data.
   */ _parseResponse = new WeakSet();
/**
 * JSON API response wrapper.
 */ export class JsonApiResponse {
    get meta() {
        return _class_private_field_get(this, _meta);
    }
    /**
   * Get raw response.
   */ get rawResponse() {
        return _class_private_field_get(this, _raw);
    }
    /**
   * Get request page limit.
   */ get pageLimit() {
        const requestConfig = _class_private_field_get(this, _raw).request;
        const decodedUrl = decodeURIComponent(requestConfig.url || '');
        const limit = new URL(decodedUrl).searchParams.get(PAGE_LIMIT_KEY);
        return Number(limit);
    }
    /**
   * Get raw response data.
   */ get rawData() {
        return _class_private_field_get(this, _rawData) || {};
    }
    /**
   * Get response data.
   */ get data() {
        return _class_private_field_get(this, _data);
    }
    /**
   * Get response HTTP status.
   */ get status() {
        return _class_private_field_get(this, _raw).status;
    }
    /**
   * Get response headers.
   */ get headers() {
        return _class_private_field_get(this, _raw).headers;
    }
    /**
   * Get response links.
   */ get links() {
        return _class_private_field_get(this, _links);
    }
    /**
   * Is response links exist.
   */ get isLinksExist() {
        return Boolean(_class_private_field_get(this, _links)) && !isEmpty(_class_private_field_get(this, _links));
    }
    createLink(link) {
        var _class_private_field_get1;
        const baseUrl = (_class_private_field_get1 = _class_private_field_get(this, _apiClient)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.baseUrl;
        if (!baseUrl) return link;
        const baseUrlPath = new URL(baseUrl).pathname;
        // Do not remove leading slash if baseUrl is root
        return baseUrlPath === '/' ? link : link.replace(new RegExp(`^${baseUrlPath}`), '');
    }
    fetchPage(page) {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.isLinksExist) {
                throw new TypeError('There are no links in response');
            }
            const link = _this.createLink(_this.links[page]);
            const jsonApiClientRequestOpts = {
                endpoint: link,
                method: _class_private_field_get(_this, _raw).request.method,
                headers: _class_private_field_get(_this, _raw).request.headers,
                isNeedRaw: _class_private_field_get(_this, _isNeedRaw)
            };
            return _class_private_field_get(_this, _apiClient).request(jsonApiClientRequestOpts);
        })();
    }
    constructor(opts){
        _class_private_method_init(this, _parseResponse);
        _class_private_field_init(this, _raw, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _rawData, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _links, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _isNeedRaw, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _meta, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _data, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _apiClient, {
            writable: true,
            value: void 0
        });
        const response = opts.raw;
        const data = response.data;
        _class_private_field_set(this, _raw, response);
        _class_private_field_set(this, _data, {});
        _class_private_field_set(this, _rawData, data || {});
        var _data_links;
        _class_private_field_set(this, _links, (_data_links = data === null || data === void 0 ? void 0 : data.links) !== null && _data_links !== void 0 ? _data_links : {});
        _class_private_field_set(this, _apiClient, opts.apiClient);
        _class_private_field_set(this, _isNeedRaw, opts.isNeedRaw);
        _class_private_method_get(this, _parseResponse, parseResponse).call(this, opts.raw, opts.isNeedRaw);
        _class_private_field_set(this, _meta, (data === null || data === void 0 ? void 0 : data.meta) || {});
    }
} /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/ 
function parseResponse(raw, isNeedRaw) {
    if (!raw.data) return;
    _class_private_field_set(this, _data, isNeedRaw ? raw.data : deserialize(raw.data));
}

//# sourceMappingURL=data:application/json;base64,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